<template>
  <div class="container-fluid">
    <div class="card-header card-custom-brown" slot="card_title">
      <i class="fas fa-cubes "></i> Gestion des cotations
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fa fa-list-alt"></i> Mes cotations
            </h3>
            <div class="box-tools float-right">
              <div class="btn-group dropdown-table-action">
                <button
                        type="button"
                        class="btn btn-box-tool btn-sm dropdown-toggle btn-action btn-options text-black"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                >
                  Options <i class="fa fa-arrow-down" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <!-- <router-link
                          :to="{ name: 'cotation-article' }"
                          class="dropdown-item"
                  >
                    <i class="fa fa-plus"></i> Nouvelle cotation
                  </router-link> -->
                  <a href="" class="dropdown-item" @click.prevent="removeMass">
                    <i class="fa fa-trash text-danger"></i> Supprimer
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center mt-4">
            <div class="col-md-4">
              <div class="form-group">
                <!-- <v-select
                        label="libelle"
                        class="w-100"
                        id="type"
                        :options="types"
                        :reduce="types => types.id"
                        :clearable="false"
                        v-model="type"
                >
                  <template v-slot:option="{ libelle }">
                    <h5 style="margin: 0">{{ libelle }}</h5>
                  </template>
                  <template #no-options="">
                    Aucune données
                  </template>
                  <template #search="{attributes, events}">
                    <input
                            class="custom-input-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                    />
                  </template>
                </v-select> -->
              </div>
            </div>
          </div>
            <Tableau ref="datatable" @onClick="remove"></Tableau>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import Tableau from "./components/MyCotationTableau";
    import * as services from "./service/services";

    export default {
        name: "MyCotations",
        data: function() {
            return {
                title: "Mes cotation - Liste",
                type: 'all',
                types: [
                    {id: 'all', libelle: 'Toutes les cotations'},
                    {id: 'cotation', libelle: 'Cotations enovoyées'},
                    {id: 'brouillon', libelle: 'Cotations en brouillon'},
                ]
            };
        },
        metaInfo(){
            return {
                title: this.title,
                titleTemplate: this.titleApp + ' | %s',
            }
        },
        components: {
            Tableau,
        },
        watch:{
            type(newVal, oldVal){
                this.$refs.datatable.loadItems(newVal);
            }
        },
        methods: {

            removeMass: function () {
                let dataArray = [];

                let selected = this.$refs.datatable.rowsSelected();
                selected.map(function(row) {
                    dataArray.push(row['id']);
                });

                if(dataArray.length){
                    let message = dataArray.length === 1 ? "Etes-vous sûr d'effectuer cette suppression ?" : "Etes-vous sûr d'effectuer ces suppressions ?";
                    this.remove(dataArray, message);
                }
            },
            remove(arrayID, message){
                let array = arrayID;

                let that = this;
                this.$swal({
                    icon: 'warning',
                    title: 'Suppression',
                    text: message,
                    showCancelButton: true,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    cancelButtonColor: '#d33',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Supprimer',
                    cancelButtonText: 'Annuler'
                }).then((result) => {
                    if (result.value) {
                        axios.delete(services.DELETE+"/"+array)
                            .then(function (response) {
                                //console.log(response.data)
                                that.$swal({
                                    position: 'top-end',
                                    icon: response.data.type,
                                    text: response.data.message,
                                    showConfirmButton: false,
                                    timer: window.Timer
                                });

                                that.$refs.datatable.loadItems();
                            })
                            .catch(function (error) {
                                console.log(error);
                            });

                    }

                });
            },
        },
    };
</script>

<style scoped></style>
